export const SET_COUMT_ADD = 'SET_COUMT_ADD' // 计数

export const SET_SEARCH_WORD = 'SET_SEARCH_WORD' // 计数


export const SET_DETAILS_ID = 'SET_DETAILS_ID' // 详情页ID

export const SET_APP_KEY = 'SET_APP_KEY' // 详情页ID